import { useNavigate } from 'react-router';
import { useState, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Header from '@components/Header/Header';
import {
  Container,
  StyledStepBar
} from './LoginWallet.styles';
import Wizard from '@components/Wizard/Wizard';
import LoadingModal from '@components/LoadingModal/LoadingModal';
import { useTranslation } from 'react-i18next';

// Import step components
import RecoveryPhraseInputStep from './steps/RecoveryPhraseInputStep';
import PINInputStep from './steps/PINInputStep';

const LoginWallet = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [currentWizardStep, setCurrentWizardStep] = useState(0);
  const [walletData, setWalletData] = useState<{mnemonic: string, secretKey: Uint8Array} | null>(null);
  const { t } = useTranslation();
  const { resetInactivity } = useAuth();
  
  const steps = [
    {
      component: <RecoveryPhraseInputStep onWalletDataGenerated={setWalletData} />,
      title: t('page.loginWallet.steps.recoveryPhrase.title')
    },
    {
      component: <PINInputStep walletData={walletData} />,
      title: t('page.loginWallet.steps.pin.title')
    }
  ];

  
  
  // Handle step change from the Wizard component
  const handleStepChange = useCallback((step: number) => {
    setCurrentWizardStep(step);
  }, []);
  
  const { login } = useAuth();

  const handleFinish = () => {
    resetInactivity()
    setIsLoading(true);
    login();
    navigate('/completed/recovery');
    setIsLoading(false);
  };

  return (
    <Container>
      <Header 
        title={steps[currentWizardStep].title}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      >
        <StyledStepBar steps={steps.length} currentStep={currentWizardStep + 1} />
      </Header>
      <Wizard 
          steps={steps.map(step => step.component)} 
          initialStep={currentWizardStep}
          onFinish={handleFinish}
          onStepChange={handleStepChange}
        />
      <LoadingModal visible={isLoading} message={t('page.loginWallet.loading')} />
    </Container>
  );
};

export default LoginWallet;
